import React from 'react';

import {
  ChevronRightIcon
} from 'zoomforth_component_lib/app_modern_icons.jsx';

import UploadOrChooseFromMediaLibraryModal
  from 'zoomforth_codesbane_editor/component_lib/upload_or_choose_from_media_library_modal.jsx';

const ConfirmCreatePresentationModal = ({
  show,
  shouldShowMediaLibrarySelectionOption,
  onRequestClose,
  onUploadClick,
  onSelectFromMediaLibraryClick
})=> (
  <UploadOrChooseFromMediaLibraryModal
    show={show} 
    shouldShowMediaLibrarySelectionOption={shouldShowMediaLibrarySelectionOption}
    title="Uploading Presentations"
    subtitle={(
      <div>
        To add a presentation to your site, you must first export your PowerPoint as a PDF.{' '}
        <a 
          target="_blank"
          href="https://support.zoomforth.com/en/articles/4777775-adding-powerpoint-files"
        >
          Learn more about PowerPoints on Zoomforth
        </a>

        <ChevronRightIcon />
      </div>
    )}
    uploadFileText="Upload PDF file"
    selectFromMediaLibraryText="Add presentation from Media Library"
    onRequestClose={onRequestClose}
    onSelectFromMediaLibraryClick={onSelectFromMediaLibraryClick}
    onUploadClick={onUploadClick}
  />
);

export default ConfirmCreatePresentationModal;
